import { PopulationPropsMap } from '../const/population-props-map.const';
import { SelectedItemInternal } from '../model/selected-item-internal.model';
import { SelectedItem } from '../model/selected-item.model';
import { currentMainState } from '../population-select.state';

export function setSelection(
    that: any,
    value: SelectedItem[] | null,
    singlePopulationSelect: boolean,
): void {
    const state = currentMainState(that);

    state.selected.clear();
    state.selectedAsArray = [];
    state.lastSelectedItem = null;

    if (value == null) {
        return;
    }

    for (const item of value) {
        const itemInternal: SelectedItemInternal = {
            population: item.population,
            populationProps: PopulationPropsMap[item.population],
            id: item.id,
            label: null,
        };

        state.selected.add(itemInternal);

        state.selectedAsArray.push({
            population: item.population,
            id: item.id,
            label: null,
        });

        if (singlePopulationSelect) {
            state.lastSelectedItem = itemInternal;
            break;
        }
    }
}
